import { useRef } from "react";

/** Keep last defined SWR value so tiles/filters don't flash empty on refetch. */
export function useKeepLastValue<T>(value: T | undefined): T | undefined {
  const lastRef = useRef<T | undefined>(value);
  if (value !== undefined) {
    lastRef.current = value;
  }
  return value ?? lastRef.current;
}
